import { render, staticRenderFns } from "./LinksLiberdade.vue?vue&type=template&id=395e7f53&scoped=true"
import script from "./LinksLiberdade.vue?vue&type=script&lang=js"
export * from "./LinksLiberdade.vue?vue&type=script&lang=js"
import style0 from "./LinksLiberdade.vue?vue&type=style&index=0&id=395e7f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e7f53",
  null
  
)

export default component.exports